import { render, staticRenderFns } from "./ProgrammesType.vue?vue&type=template&id=54055dc1&scoped=true"
import script from "./ProgrammesType.vue?vue&type=script&lang=js"
export * from "./ProgrammesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54055dc1",
  null
  
)

export default component.exports